// extracted by mini-css-extract-plugin
module.exports = {"tcoButton":"_3-BdQl"};